import styles from "../styles/Groups.module.css";
import { Card, Container, Row } from "react-bootstrap";
import Logo from "../assets/logo.png";
import { Link } from "react-router-dom";
import { Group1Schema } from "../models/Group1Items";

interface HomePageLoggedInViewProps {
    group1: Group1Schema[];
}
const HomePageLoggedInView = ({group1}: HomePageLoggedInViewProps) => {

    return (
        <Container fluid className="pt-2">
            <Row xs={1} sm={1} md={1} lg={1} xl={1} className={`px-0 justify-content-center fs-6`}>
                {group1.map(group => (
                    <Card key={group.CODE} as={Link} to={`/g1/${group.CODE}`} className={`${styles.groupCard} shadow rounded border-0 p-0 g-3 g-sm-4 mx-0 mx-sm-4 my-1 my-sm-2 bg-dark d-flex flex-row-reverse`}>
                    <Row className={`${styles.groupCardArrow} fs-5 text-secondary align-items-center justify-content-center m-0 p-0`}>
                        <Card.Text className="text-center p-0">{'>'}</Card.Text>
                    </Row>
                    <Row className={`${styles.groupCardText} bg-light align-items-center mx-0 p-0`}>
                        <Card.Text className={`${styles.groupCardTex} text-dark text-center`}>{group.NAME}</Card.Text>
                    </Row>
                    <Row className={`${styles.groupCardImg} align-items-center text-center justify-content-center m-0 p-0`}>
                        <Card.Img variant="top" src={Logo} className="p-0"></Card.Img>
                    </Row>
                </Card>
                ))}
            </Row>
        </Container>
    );
}

export default HomePageLoggedInView;